import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoRicevuteFiscaliStep2Component } from './conservazione-carica-documento-ricevute-fiscali-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-ricevute-fiscali-step2', {
            url: '/conservazione-carica-ricevute-fiscali',
            ncyBreadcrumb: {
                label: 'Carica Ricevute Fiscali',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-ricevute-fiscali-step2 flex="100"></conservazione-carica-documento-ricevute-fiscali-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoRicevuteFiscaliStep2Module: string = ng
    .module('conservazione-carica-documento-ricevute-fiscali-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoRicevuteFiscaliStep2', ConservazioneCaricaDocumentoRicevuteFiscaliStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-ricevute-fiscali-step2/conservazione-carica-documento-ricevute-fiscali-step2.module.ts